<style>
.color-scheme-dark {
  background-color: #293145;
  color: #ccd9e8;
}

.color-scheme-dark .btn {
  color: #293145 !important;
}

.color-scheme-dark .element-header {
  color: #ccd9e8;
}

.color-scheme-dark table * {
  color: #ccd9e8;
}
</style>
<template>
  <div>
    <div class="content-i row">
      <div class="content-box col-12">
        <div class="row">
          <div class="col-sm-12 col-md-7 pt-2">
            <div class="element-wrapper">
              <h6>Crear o modificar el Producto</h6>
              <hr />
              <router-link
                class="btn btn-default"
                :to="{ name: 'cat-productos', params: {} }"
              >
                <i class="fas fa-angle-left"></i>
                Regresar a listado
              </router-link>
              <div class="element-box">
                <tr>
                  <td width="800px">
                    <ProductoSelectComponent
                      :disabled_view="true"
                      title="Buscar nuevo Producto"
                      :current="current"
                    />
                  </td>
                  <td class="text-right">
                    <br />
                    <button
                      @click="buscarProducto(current)"
                      type="button"
                      class="btn btn-primary"
                      v-if="current.producto"
                    >
                      Ir
                    </button>
                  </td>
                </tr>
                <div class="row">
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.sku && current.errors.sku.length > 0,
                        }"
                        >Sku</label
                      >
                      <input
                        :disabled="true"
                        v-model="current.sku"
                        autofocus="autofocus"
                        class="form-control"
                        :readonly="true"
                        placeholder="Sku"
                        type="text"
                        v-bind:class="{
                          'is-invalid':
                            current.errors.sku && current.errors.sku.length > 0,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.sku"
                        class="form-text text-danger"
                        >{{ current.errors.sku[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-9">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.nombre && current.errors.nombre.length > 0,
                        }"
                        >Nombre</label
                      >
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        autofocus="autofocus"
                        placeholder="Nombre"
                        v-bind:class="{
                          'is-invalid':
                            current.errors.nombre && current.errors.nombre.length > 0,
                        }"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                        >{{ current.errors.nombre[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.categoria &&
                            current.errors.categoria.length > 0,
                        }"
                        >Categoria</label
                      >
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        v-model="current.categoria"
                        @change="refreshSubCategorias"
                      >
                        <option
                          v-for="(c, key) in categorias"
                          :value="c.codigo"
                          :key="key"
                        >
                          {{ c.codigo }} - {{ c.nombre }}
                        </option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.categoria"
                        class="form-text text-danger"
                        >{{ current.errors.categoria[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.sub_categoria &&
                            current.errors.sub_categoria.length > 0,
                        }"
                        >Sub Categoria</label
                      >
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        v-model="current.sub_categoria"
                        @input="$emit('input', $event.target.value)"
                      >
                        <option
                          v-for="(c, key) in subcategorias"
                          :value="c.codigo"
                          :key="key"
                        >
                          {{ c.codigo }} - {{ c.nombre }}
                        </option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.sub_categoria"
                        class="form-text text-danger"
                        >{{ current.errors.sub_categoria[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.grupo && current.errors.grupo.length > 0,
                        }"
                        >Grupo</label
                      >
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        :readonly="current.pk != null"
                        :disabled="current.pk != null"
                        v-model="current.grupo"
                      >
                        <option v-for="(c, key) in grupos" :value="c.id" :key="key">
                          {{ c.nombre }}
                        </option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.grupo"
                        class="form-text text-danger"
                        >{{ current.errors.grupo[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <br />
                <nav>
                  <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a
                      class="col col-sm-1 nav-item nav-link active"
                      id="nav-home-tab"
                      data-toggle="tab"
                      href="#nav-home"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                      >General</a
                    >
                    <a
                      v-if="current.lista_precios"
                      class="col col-sm-1 nav-item nav-link"
                      id="barras-tab"
                      data-toggle="tab"
                      href="#barras"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                      >Barras</a
                    >
                    <a
                      v-if="current.productolote_set"
                      class="nav-item nav-link"
                      id="unidad-tab"
                      data-toggle="tab"
                      href="#unidad"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                      >Uds. Medidas</a
                    >
                    <a
                      v-if="current.productolote_set"
                      class="nav-item nav-link"
                      id="proveedores-tab"
                      data-toggle="tab"
                      href="#proveedores"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                      >Proveedores</a
                    >

                    <a
                      v-if="current.productolote_set"
                      class="col col-sm-1 nav-item nav-link"
                      id="Contable-tab"
                      data-toggle="tab"
                      href="#productoimagen"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                      >Imagenes</a
                    >
                  </div>
                </nav>
                <div class="tab-content element-box" id="nav-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.ultimo_costo &&
                                current.errors.ultimo_costo.length > 0,
                            }"
                            >Costo Actual</label
                          >
                          <input
                            v-on:keyup.enter="guardar"
                            v-model="current.ultimo_costo"
                            class="form-control"
                            disabled
                            placeholder="Costo Actual"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.ultimo_costo &&
                                current.errors.ultimo_costo.length > 0,
                            }"
                            type="text"
                          />
                          <small
                            v-if="current.errors && current.errors.ultimo_costo"
                            class="form-text text-danger"
                            >{{ current.errors.ultimo_costo[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.ultimo_precio_compra &&
                                current.errors.ultimo_precio_compra.length > 0,
                            }"
                            >Ultimo Precio Compra</label
                          >
                          <input
                            v-on:keyup.enter="guardar"
                            v-model="current.ultimo_precio_compra"
                            class="form-control"
                            disabled
                            placeholder="Ultimo Precio Compra"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.ultimo_precio_compra &&
                                current.errors.ultimo_precio_compra.length > 0,
                            }"
                            type="text"
                          />
                          <small
                            v-if="current.errors && current.errors.ultimo_precio_compra"
                            class="form-text text-danger"
                            >{{ current.errors.ultimo_precio_compra[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.costo_ponderado &&
                                current.errors.costo_ponderado.length > 0,
                            }"
                            >Costo Ponderado</label
                          >
                          <input
                            v-on:keyup.enter="guardar"
                            v-model="current.costo_ponderado"
                            class="form-control"
                            disabled
                            placeholder="Costo Ponderado"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.costo_ponderado &&
                                current.errors.costo_ponderado.length > 0,
                            }"
                            type="text"
                          />
                          <small
                            v-if="current.errors && current.errors.costo_ponderado"
                            class="form-text text-danger"
                            >{{ current.errors.costo_ponderado[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.codigo_fabricante &&
                                current.errors.codigo_fabricante.length > 0,
                            }"
                            >Código del fabricante</label
                          >
                          <input
                            v-on:keyup.enter="guardar"
                            v-model="current.codigo_fabricante"
                            class="form-control"
                            placeholder="Código del Fabricante"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.codigo_fabricante &&
                                current.errors.codigo_fabricante.length > 0,
                            }"
                            type="text"
                          />
                          <small
                            v-if="current.errors && current.errors.codigo_fabricante"
                            class="form-text text-danger"
                            >{{ current.errors.codigo_fabricante[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.codigo_fabricante &&
                                current.errors.codigo_fabricante.length > 0,
                            }"
                            >Código original</label
                          >
                          <input
                            v-on:keyup.enter="guardar"
                            v-model="current.codigo_original"
                            class="form-control"
                            placeholder="Código original"
                            v-bind:class="{
                              'is-invalid':
                                current.errors && current.errors.codigo_original,
                            }"
                            type="text"
                          />
                          <small
                            v-if="current.errors && current.errors.codigo_fabricante"
                            class="form-text text-danger"
                            >{{ current.errors.codigo_fabricante[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              checked
                              class="form-check-input"
                              name="optionsRadios"
                              v-model="current.activo"
                              type="radio"
                              value="true"
                            />Activo
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              class="form-check-input"
                              v-model="current.activo"
                              name="optionsRadios"
                              type="radio"
                              value="false"
                            />Inactivo
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              checked
                              class="form-check-input"
                              v-model="current.consumible"
                              type="checkbox"
                              value="false"
                            />Consumible
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              class="form-check-input"
                              v-model="current.peso"
                              type="checkbox"
                              value="false"
                            />Peso
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              class="form-check-input"
                              v-model="current.es_servicio"
                              type="checkbox"
                              value="false"
                            />¿Es Servicio?
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              class="form-check-input"
                              v-model="current.es_activo_fijo"
                              type="checkbox"
                              value="false"
                            />¿Es activo fijo?
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              class="form-check-input"
                              v-model="current.permitir_multiplicador"
                              type="checkbox"
                              value="false"
                            />Permitir Multiplicador "*"
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="barras"
                    role="tabpanel"
                    aria-labelledby="barras-tab"
                  >
                    <ProductoBarraFormComponent
                      v-if="current.productolote_set"
                      :sku="current.sku"
                    />
                  </div>
                  <div
                    class="tab-pane fade"
                    id="unidad"
                    role="tabpanel"
                    aria-labelledby="unidad-tab"
                  >
                    <div class="row">
                      <div class="col-md-12">
                        <h6>Configuracion de Unidades de Medidas</h6>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors && current.errors.unidad_medida_compra,
                            }"
                            >Unidad de medida de compra</label
                          >
                          <v-select
                            label="nombre"
                            v-model="current.unidad_medida_compra"
                            :filterable="false"
                            :options="unidades_medidas_compra"
                            @search="onSearchCompra"
                          >
                            <template slot="no-options">unidad medida...</template>
                            <template slot="option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.nombre }}
                              </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.nombre }}
                              </div>
                            </template>
                          </v-select>
                          <small
                            v-if="current.errors && current.errors.unidad_medida_compra"
                            class="form-text text-danger"
                            >{{ current.errors.unidad_medida_compra }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors && current.errors.unidad_medida_solicitud,
                            }"
                            >Unidad de medida de solicitud</label
                          >
                          <v-select
                            label="nombre"
                            v-model="current.unidad_medida_solicitud"
                            :filterable="false"
                            :options="unidades_medidas_solicitud"
                            @search="onSearch"
                          >
                            <template slot="no-options">unidad medida...</template>
                            <template slot="option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.nombre }}
                              </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.nombre }}
                              </div>
                            </template>
                          </v-select>
                          <small
                            v-if="
                              current.errors && current.errors.unidad_medida_solicitud
                            "
                            class="form-text text-danger"
                            >{{ current.errors.unidad_medida_solicitud }}</small
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <hr />
                        <h6>Listado de Unidades de Medida para Venta</h6>
                      </div>
                      <div class="col-sm-8 col-md-8">
                        <div class="table-responsive">
                          <table class="table table-hover">
                            <thead class="table-primary">
                              <tr>
                                <th class="text-center">Nombre</th>
                                <th class="text-center">Unidades</th>
                                <th class="text-center">Revision al facturar</th>
                                <th class="text-center">Opciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="det in current.productounidadmedida_set"
                                v-bind:key="det.id"
                              >
                                <td class="text-left">
                                  {{ det.unidad_medida.nombre }}
                                </td>
                                <td class="text-center">
                                  {{ det.unidad_medida.cantidad_unidades }}
                                </td>
                                <td class="text-center">
                                  <span
                                    v-bind:class="{
                                      'status-pill green':
                                        det.revision_al_despachar == true,
                                      'status-pill red':
                                        det.revision_al_despachar == false,
                                    }"
                                  ></span>
                                </td>
                                <td class="text-center">
                                  <div class="row">
                                    <button
                                      v-if="det.revision_al_despachar == false"
                                      type="button"
                                      class="btn btn-sm btn-dark"
                                      @click="activarRevision(det)"
                                    >
                                      Cambiar revisión
                                    </button>
                                    <button
                                      v-if="det.revision_al_despachar == true"
                                      type="button"
                                      class="btn btn-sm btn-dark"
                                      @click="desactivarRevision(det)"
                                    >
                                      Cambiar revisión
                                    </button>
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-danger"
                                      @click="eliminarUnidad_medida(det)"
                                    >
                                      Eliminar
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <UnidadMedidaSelectComponent
                          :current="current"
                          titulo="Agregar Unidad de Medida"
                        />
                        <button
                          type="button"
                          class="btn btn-sm btn-success btn-block"
                          @click="agregarUnidadMedida"
                        >
                          Agregar
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="contable"
                    role="tabpanel"
                    aria-labelledby="contable-tab"
                  ></div>
                  <div
                    class="tab-pane fade"
                    id="proveedores"
                    role="tabpanel"
                    aria-labelledby="proveedores-tab"
                  >
                    <ProductoProveedorFormComponent
                      v-if="current.productolote_set"
                      :sku="current.sku"
                    />
                  </div>
                  <div
                    class="tab-pane fade"
                    id="productoimagen"
                    role="tabpanel"
                    aria-labelledby="productoimagen-tab"
                  >
                    <ProductoImagenFormComponent
                      v-if="current.productolote_set"
                      :sku="current.sku"
                    />
                  </div>
                  <small
                    v-if="current.errors && current.errors.non_field_errors"
                    class="form-text text-danger"
                    >{{ current.errors.non_field_errors[0] }}</small
                  >
                </div>
                <div class="form-buttons-w">
                  <button class="btn btn-primary" @click="guardar(current)">
                    Guardar
                  </button>
                  <router-link
                    class="btn btn-info"
                    :to="{ name: 'cat-categorias' }"
                    target="_blank"
                  >
                    <i class="fa fa-back"></i>
                    Nueva Categoria
                  </router-link>
                  <button
                    type="button"
                    data-target="#modalClonarProducto"
                    data-toggle="modal"
                    class="btn btn-outline-secondary float-right"
                  >
                    <i class="fa fa-back"></i>
                    Cambiar Presentación
                  </button>
                  <ClonarProductoModalComponent
                    :producto="current"
                    @cerrandomodal="refresh"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 col-md-5 pt-2 color-scheme-dark"
            v-if="current.pk != null"
          >
            <div class="element-wrapper">
              <h6 class="element-header">Opciones Múltiples</h6>
              <div class="element-box-tp">
                <div class="el-buttons-list full-width">
                  <div class="btn-group col-sm-12">
                    <router-link
                      class="btn btn-primary col-sm-6"
                      :to="{ name: 'cat-productos-precios', params: {} }"
                    >
                      <i class="fa fa-dollar-sign"></i>&nbsp;
                      <span>Ver Precios</span>
                    </router-link>
                    &nbsp; &nbsp;
                    <a class="btn btn-info col-sm-6" @click="imprimir_barra">
                      <i class="fa fa-barcode"></i>&nbsp;
                      <span>Imprimir Barra</span>
                    </a>
                  </div>
                  <div class="btn-group col-sm-12">
                    <a
                      type="button"
                      class="btn btn-info col-sm-6"
                      data-toggle="modal"
                      data-target="#listaPrecio"
                    >
                      <i class="fa fa-barcode"></i>&nbsp;
                      <span>Imprimir Hablador</span>
                    </a>
                    &nbsp; &nbsp;
                    <router-link
                      class="btn btn-primary col-sm-6"
                      :to="{
                        name: 'inventario-reportes-kardex',
                        params: {
                          sku: current.pk,
                        },
                      }"
                    >
                      <i class="fa fa-list-ol"></i>&nbsp;
                      <span>Kardex</span>
                    </router-link>
                  </div>
                  <div class="btn-group col-sm-12">
                    <button
                      data-toggle="modal"
                      data-target="#opcionesAvanzadas"
                      class="btn btn-primary btn-block col-sm-6"
                    >
                      <i class="fas fa-user-cog"></i> Opciones Avanzadas
                    </button>
                    &nbsp; &nbsp;
                    <button
                      @click="abrirModalLog()"
                      class="btn btn-info btn-block col-sm-6"
                    >
                      <i class="fas fa-history"></i> Log de transacciones
                    </button>
                  </div>
                  <div v-if="current.sku">
                    <LogModalComponent
                      modulo="cat"
                      transac="productos"
                      :id="current.sku"
                    />
                  </div>
                  <OpcionesAvanzadasModalComponent :current="current" />
                </div>
              </div>
            </div>
            <ProductoTiendaTableComponent :current="current" @refresh="refresh" />
            <div class="element-wrapper">
              <div class="element-actions"></div>
              <h6 class="element-header">Precios</h6>
              <div class="element-box-tp" style="padding: 0em !important">
                <h3>
                  <table class="table table-compact smaller mb-0">
                    <thead>
                      <tr>
                        <th>Lista de Precio</th>
                        <th>Unidad de Medida</th>
                        <th>Precio</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="detalle in current.lista_precios"
                        v-bind:key="detalle.id"
                      >
                        <td>{{ detalle.lista_precio.nombre }}</td>
                        <td>{{ detalle.unidad_medida.nombre }}</td>
                        <td>{{ detalle.precio }}</td>
                      </tr>
                    </tbody>
                  </table>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="listaPrecio"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">¿Qué tienda?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <select class="form-control" v-model="tienda">
                <option v-for="(data, key) in tiendas" :value="data.codigo" :key="key">
                  {{ data.nombre }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="imprimir_hablador" class="btn btn-primary">
              Imprimir
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import { mapGetters } from "vuex";
import ProductosService from "@/services/catalogos/ProductosService";
import ProductosTiendaService from "@/services/catalogos/ProductosTiendaService";
import Notifications from "@/notifications/notifications";
import ProductoBarraFormComponent from "@/components/cat/productos/ProductoBarraFormComponent";
import ProductoProveedorFormComponent from "@/components/cat/productos/ProductoProveedorFormComponent";
import ProductoTiendaTableComponent from "@/components/cat/productos/ProductoTiendaTableComponent";
import ProductoImagenFormComponent from "@/components/cat/productos/ProductoImagenFormComponent";
import ProductoUnidadMedidaService from "@/services/catalogos/ProductoUnidadMedidaService";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";
import CuentaContableConfigSelectComponent from "@/components/commons/CuentaContableConfigSelectComponent";
import ClonarProductoModalComponent from "@/components/cat/productos/ClonarProductoModalComponent";
import OpcionesAvanzadasModalComponent from "@/components/cat/productos/OpcionesAvanzadasModalComponent";
import DynamicService from "@/services/commons/DynamicService";
import LogModalComponent from "@/components/commons/LogModalComponent";

export default {
  components: {
    ProductoSelectComponent,
    ProductoBarraFormComponent,
    ProductoProveedorFormComponent,
    ProductoTiendaTableComponent,
    ProductoImagenFormComponent,
    UnidadMedidaSelectComponent,
    CuentaContableConfigSelectComponent,
    ClonarProductoModalComponent,
    OpcionesAvanzadasModalComponent,
    LogModalComponent,
  },
  data() {
    return {
      unidades_medidas_solicitud: [],
      unidades_medidas_compra: [],
      editando: false,
      grupos: [],
      tienda: "",
      tiendas: "",
      current: {
        estado: "A",
        unidad_medida: "",
        activo: true,
        cta_inv: "",
        cta_produccion: "",
        cta_cst_prod: "",
        cta_cst_vta: "",
        cta_compra_l: "",
        cta_ventas: "",
        cta_dev_vta: "",
        cta_compra_i: "",
        errors: {},
        unidad_medida: "",
        sku: null,
        unidad_medida_compra: "",
        unidad_medida_solicitud: null,
        productolote_set: "",
        producto: {},
        permitir_compra: false,
        consumible: false,
        permitir_venta: false,
        pk: null,
      },
      listas_precio: "",
      options: [],
      stocks: {
        results: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      categorias: "catalogos/categorias",
      subcategorias: "catalogos/subcategorias",
      unidades_medidas: "catalogos/unidades_medidas",
    }),
  },
  mounted() {
    let self = this;
    /*self.$store.dispatch("catalogos/categorias", {
      quitar_paginacion: true
    });*/
    self.refreshGrupos();
    self.refreshDataUnidadmedidaSolicitud();
    self.refreshDataUnidadmedidaCompra();
    self.refreshCategorias();
    self.refreshTienda();
    if (self.$route.params.sku) {
      self.refresh();
    }
    //self.refreshSubCategorias();
  },
  methods: {
    abrirModalLog() {
      $("#modalLog").modal("show");
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      DynamicService.fetch("cat", "unidad-medida", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.unidades_medidas_solicitud = res.data;
        loading(false);
      });
    }, 350),
    onSearchCompra(search, loading) {
      loading(true);
      this.searchCompra(loading, search, this);
    },
    searchCompra: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      DynamicService.fetch("cat", "unidad-medida", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.unidades_medidas_compra = res.data;
        loading(false);
      });
    }, 350),
    refreshDataUnidadmedidaSolicitud() {
      let self = this;
      DynamicService.fetch("cat", "unidad-medida", {
        page: 1,
      }).then((res) => {
        self.unidades_medidas_solicitud = res.data.results;
      });
    },
    refreshDataUnidadmedidaCompra() {
      let self = this;
      DynamicService.fetch("cat", "unidad-medida", {
        page: 1,
      }).then((res) => {
        self.unidades_medidas_compra = res.data.results;
      });
    },
    activarRevision(det) {
      DynamicService.save("cat", "producto-unidad_medida", {
        revision_al_despachar: true,
        id: det.id,
        producto: this.current.pk,
        unidad_medida: det.unidad_medida.id,
      }).then((response) => {
        det.revision_al_despachar = true;
      });
    },
    desactivarRevision(det) {
      DynamicService.save("cat", "producto-unidad_medida", {
        revision_al_despachar: false,
        producto: this.current.pk,
        id: det.id,
        unidad_medida: det.unidad_medida.id,
      }).then((response) => {
        det.revision_al_despachar = false;
      });
    },
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    imprimir_barra() {
      let op;
      op = this.$route.params.sku;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/Barras.jrxml&sku=${op}`
      );
    },
    buscarProducto(current) {
      let self = this;
      self.$router.push({
        name: "cat-productos-editar",
        params: { sku: current.producto.sku },
      });
      location.reload();
    },
    imprimir_hablador() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/HabladorPorTienda.jrxml&tienda=${self.tienda}&sku=${this.current.sku}`
      );
      $("#listaPrecio").modal("hide");
    },
    // barcodeUrl() {
    // let self = this;
    //const baseApiUrl = process.env.VUE_APP_ROOT_API;
    //eturn `${baseApiUrl}/cat/reporte/?report_name=Barras&sku=${
    // self.current.sku
    //}`;
    //    },
    //    habladorUrl() {
    //      let self = this;
    //      const baseApiUrl = process.env.VUE_APP_ROOT_API;
    //      return `${baseApiUrl}/cat/reporte/?report_name=Hablador&sku=${
    //        self.current.sku
    //      }`;
    //    },
    refresh() {
      let self = this;
      ProductosService.getById(self.$route.params.sku).then((response) => {
        self.current = response.data;
        self.current.unidad_medida_compra = response.data.unidad_medida_compra_obj;
        self.current.unidad_medida_solicitud = response.data.unidad_medida_solicitud_obj;
        self.current.errors = [];
        self.current.pk = self.current.sku;
        self.current.estado = "A";
        self.refreshSubCategorias();
      });
    },
    refreshCategorias() {
      let self = this;
      self.$store.dispatch("catalogos/categorias", {
        activa: true,
        categoria: self.current.categoria,
        quitar_paginacion: true,
      });
    },
    refreshSubCategorias() {
      let self = this;
      self.$store.dispatch("catalogos/subcategorias", {
        activa: true,
        categoria: self.current.categoria,
        quitar_paginacion: true,
      });
    },
    refreshGrupos() {
      let self = this;
      DynamicService.fetch("cat", "grupo-producto", {
        quitar_paginacion: true,
      }).then((res) => {
        self.grupos = res.data;
      });
    },
    refreshStocks() {
      let self = this;
      ProductosTiendaService.fetch({
        producto: self.current.sku,
      }).then((response) => {
        self.stocks = response.data;
      });
    },
    guardar(current) {
      let self = this;
      var current = Object.assign({}, self.current);
      if (self.$route.params.sku) {
        current.id = self.$route.params.sku;
      }
      if (current.unidad_medida_compra) {
        current.unidad_medida_compra = current.unidad_medida_compra.id;
      }
      if (current.unidad_medida_solicitud) {
        current.unidad_medida_solicitud = current.unidad_medida_solicitud.id;
      }
      ProductosService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.pk = self.current.sku;
          self.current.errors = {};
          Notifications.alert.success("Producto", "Se ha guardado la Información.");
          self.sku = res.data.pk;
          if (current.pk == null) {
            self.$router.push({
              name: "cat-productos-editar",
              params: { sku: self.current.sku },
            });
          }
          self.refresh();
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
          });
          if (error.response.data && error.response.data.detail) {
            Notifications.alert.error("Nuevo producto", error.response.data.detail);
          }
        });
    },
    showModal(e) {
      e.preventDefault();
    },
    onSearchUnidadMedida(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/unidades_medidas", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),

    agregarUnidadMedida() {
      let self = this;
      if (self.current.unidad_medida == null || self.current.unidad_medida == "") {
        alert("Unidad de Medida requerida");
        return;
      }
      let params = {
        producto: self.current.pk,
        unidad_medida: self.current.unidad_medida,
      };
      ProductoUnidadMedidaService.save(params)
        .then((res) => {
          self.refresh();
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            alert(self.current.errors.non_field_errors);
            return;
          });
        });
    },
    eliminarUnidad_medida(det) {
      let self = this;
      if (!confirm("¿Desea eliminar la unidad de Medida?")) {
        return;
      }
      DynamicService.postAction(
        "cat",
        "producto-unidad_medida",
        det.id,
        "eliminar_precio_unidad_medida"
      )
        .then((response) => {
          Notifications.alert.success(
            "Eliminar Unidad de medida y desactivar precios",
            "Realizado Exitosamente"
          );
          this.refresh();
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Eliminar Unidad de medida y desactivar precios",
            "No se pudo completar el procedimiento"
          );
        });
    },
  },
};
</script>
